import React, { useState, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";

import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";


function Addsupplier() {
  const toast = useRef(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    shopname: "",
    type: "",
    photo: "",
    account_holder: "",
    account_number: "",
    bank_name: "",
    city:"",
    countrySubDivisionCode:"",
    postalCode:""
  });

    const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phone || isNaN(formData.phone)) newErrors.phone = "Phone is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.shopname) newErrors.shopname = "Shop Name is required";
    if (!formData.account_holder) newErrors.account_holder = "Account holder is required";
    if (!formData.account_number) newErrors.account_number = "Account Number is required";
    if (!formData.bank_name) newErrors.bank_name = "Bank name is required";

    // Add other field validations as needed
    return newErrors;
  };

  const refs = {
    name: useRef(null),
    email: useRef(null),
    phone: useRef(null),
    address: useRef(null),
    shopname: useRef(null),
    account_holder: useRef(null),
    account_number: useRef(null),
    bank_name: useRef(null),
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    supplierservices.createsupplier(formData).then((response)=>{
      setLoading(true);
        if(response.status == 200){
            setFormData(formData);
            setLoading(false);
            toast.current.show({ severity: 'success', summary: 'Supplier', detail: 'Supplier created successfully' });  

        }else{
          setLoading(false);
            toast.current.show({ severity: 'error', summary: 'Supplier', detail: response.data.data });     
        }
    }).catch((error)=>{
      setLoading(false);
        toast.current.show({ severity: 'error', summary: 'Supplier', detail: 'Not Created' });     
    });
    console.log(formData); // You can send this to your API
  };

  const handleClose = () => {
    // Reset form or close modal logic
    // console.log('Form Closed');

  };

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Supplier / Create Supplier"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        {/* <Titlebar text={"Create Supplier"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4">
                  <form onSubmit={handleSubmit} >
                    <div className="row">
                      {/* Name */}
                      <div className="col-md-6 form-group">
                        {/* <label>Name</label> */}
                         <Label name="Name" />
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter Name"
                          ref={refs.name}
                          required
                        />
                      {/* {errors.name && <span style={{ color: "red" }}>{errors.name}</span>} */}

                      </div>

                      {/* Email */}
                      <div className="col-md-6 form-group">
                        <Label name="Email" />
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter Email"
                          ref={refs.email}
                          required
                        />
                        {/* {errors.email && <span style={{ color: "red" }}>{errors.email}</span>} */}
                      </div>

                      {/* Phone */}
                      <div className="col-md-6 form-group">
                        {/* <label>Phone</label> */}
                        <Label name="Phone" />
                        <input
                          type="tel"
                          name="phone"
                          className="form-control"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Enter Phone"
                          ref={refs.phone}
                          required
                        />
                        {/* {errors.phone && <span style={{ color: "red" }}>{errors.phone}</span>} */}
                      </div>

                      {/* Address */}
                      <div className="col-md-6 form-group">
                        {/* <label>Address</label> */}
                        <Label name="Address" />
                        <input
                          type="text"
                          name="address"
                          className="form-control"
                          value={formData.address}
                          onChange={handleChange}
                          placeholder="Enter Address"
                          ref={refs.address}
                          required
                        />
                        {/* {errors.address && <span style={{ color: "red" }}>{errors.address}</span>} */}
                      </div>

                      <div className="col-md-6 form-group">
                        {/* <label>City</label> */}
                        <Label name="City" />
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          value={formData.city}
                          onChange={handleChange}
                          placeholder="City"
                          ref={refs.city}
                          required
                        />
                        {/* {errors.address && <span style={{ color: "red" }}>{errors.address}</span>} */}
                      </div>

                       <div className="col-md-6 form-group">
                        {/* <label>Country SubDivision Code</label> */}
                        <Label name="Country SubDivision Code" />
                        <input
                          type="text"
                          name="countrySubDivisionCode"
                          className="form-control"
                          value={formData.countrySubDivisionCode}
                          onChange={handleChange}
                          placeholder="Country SubDivision Code"
                          ref={refs.countrySubDivisionCode}
                          required
                        />
                        {/* {errors.address && <span style={{ color: "red" }}>{errors.address}</span>} */}
                      </div>

                      <div className="col-md-6 form-group">
                        {/* <label>PostalCode</label> */}
                         <Label name="PostalCode" />
                        <input
                          type="text"
                          name="postalCode"
                          className="form-control"
                          value={formData.postalCode}
                          onChange={handleChange}
                          placeholder="Postal Code"
                          ref={refs.postalCode}
                          required
                        />
                        {/* {errors.address && <span style={{ color: "red" }}>{errors.address}</span>} */}
                      </div>

                    

                      {/* Shop Name */}
                      <div className="col-md-6 form-group">
                        {/* <label>Shop Name</label> */}
                         <Label name="Shop Name" />
                        <input
                          type="text"
                          name="shopname"
                          className="form-control"
                          value={formData.shopname}
                          onChange={handleChange}
                          placeholder="Enter Shop Name"
                          ref={refs.shopname}
                        />
                         {/* {errors.shopname && <span style={{ color: "red" }}>{errors.shopname}</span>} */}
                      </div>

                      {/* Type */}
                      <div className="col-md-6 form-group">
                        {/* <label>Type</label> */}
                        <Label name="Type" />
                        <select className="form-control" name="type" value={formData.type}
                          onChange={handleChange} required>
                          <option value="wholeseler">Whole Saler</option>
                          <option value="distributor">Distributor</option>
                          <option value="retailer">Retailer</option>
                          <option value="manufacturer">Manufacturer</option>
                        </select>

                      </div>

                      {/* Photo */}
                      <div className="col-md-6 form-group">
                        <label>Photo URL</label>
                        <input
                          type="text"
                          name="photo"
                          className="form-control"
                          value={formData.photo}
                          onChange={handleChange}
                          placeholder="Enter Photo URL"
                        />
                      </div>

                      {/* Account Holder */}
                      <div className="col-md-6 form-group">
                        {/* <label>Account Holder</label> */}
                        <Label name="Account Holder" />
                        <input
                          type="text"
                          name="account_holder"
                          className="form-control"
                          value={formData.account_holder}
                          onChange={handleChange}
                          placeholder="Enter Account Holder"
                          ref={refs.account_holder}
                          required
                        />
                        {/* {errors.account_holder && <span style={{ color: "red" }}>{errors.account_holder}</span>} */}
                      </div>

                      {/* Account Number */}
                      <div className="col-md-6 form-group">
                        {/* <label>Account Number</label> */}
                        <Label name="Account Number" />
                        <input
                          type="text"
                          name="account_number"
                          className="form-control"
                          value={formData.account_number}
                          onChange={handleChange}
                          placeholder="Enter Account Number"
                          ref={refs.account_number}
                          required
                        />
                        {/* {errors.account_number && <span style={{ color: "red" }}>{errors.account_number}</span>} */}
                      </div>

                      {/* Bank Name */}
                      <div className="col-md-6 form-group">
                        <label>Bank Name</label>
                        
                        <input
                          type="text"
                          name="bank_name"
                          className="form-control"
                          value={formData.bank_name}
                          onChange={handleChange}
                          placeholder="Enter Bank Name"
                          // ref={refs.bank_name}
                        />
                         {/* {errors.bank_name && <span style={{ color: "red" }}>{errors.bank_name}</span>} */}
                      </div>

                      <div className="col-md-6 form-group">
                        {/* <label>Type</label> */}
                        <Label name="Category" />
                        <select className="form-control" name="category" value={formData.category}
                          onChange={handleChange} required>
                          <option value="inhouse">In House</option>
                          <option value="external">External</option>
                        </select>

                      </div>
                    </div>

                    <br></br>
                    {/* <br></br> */}
                    <div className="row">
                        <div className='col-md-6'>
                        <button
                        type="submit"
                        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                         disabled={loading}
                        >
                        {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                                        Loading...
                                    </>
                                ) : (
                                    "Save"
                                )}
                        </button>
                        </div>

                        <div className='col-md-6'>
                        <button
                        type="reset"
                        className="btn color-white w-100 rounded custom-btn-color-secondary"
                        // onClick={handleClose}
                        >
                        Close
                        </button>
                        </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Addsupplier;
